import { useQuery } from '@apollo/client';
import { PAYMENT_REQUESTS } from '@src/graphql/queries/paymentRequest';
import { useAuth } from '@src/hooks/useAuth';
import { useCallback, useMemo } from 'react';
export const usePaymentRequests = ({ id, statuses, programId, employeeId, useCurrentUser = true, orderBy, orderByDir, } = {}) => {
    const { currentUser } = useAuth();
    const empId = (useCurrentUser && currentUser?.employeeId) || employeeId;
    const { data, error, loading } = useQuery(PAYMENT_REQUESTS, {
        variables: {
            spec: {
                id,
                employeeId: empId,
                programId,
                statuses,
                orderBy,
                orderByDir,
            },
        },
        skip: !empId,
    });
    const paymentRequests = useMemo(() => (data?.paymentRequests || []), [data?.paymentRequests]);
    const find = useCallback((id) => paymentRequests.find(req => req.id === id), [paymentRequests]);
    return {
        paymentRequests,
        error,
        loading,
        find,
    };
};
